import { CompareQuestionGroupDto } from "./CompareQuestionGroupDto";
import { MessageStatusDto } from "./MessageStatusDto";

export class CompareDto {
    public isConfigured: boolean;

    public compareQuestionGroups: CompareQuestionGroupDto[];
    public messageStatuses: MessageStatusDto[];

    static Empty(): CompareDto {
        return {
            isConfigured: false,
            compareQuestionGroups: [],
            messageStatuses: []
        }
    }
}